<template>
<div>

<div class="box box-primary">
  <div class="box-header with-border"> 
    <h3 class="box-title">Voucher</h3>
    <span class="">
      <router-link to="/paymentvoucher" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Payment</router-link>
      <router-link to="/receiptvoucher" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Receipt</router-link>
      <router-link to="/contravoucher" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Contra</router-link>
      <router-link to="/journalvoucher" class="btn btn-xs btn-primary"><i class="fa fa-plus"></i> Journal</router-link>
    </span>
    <div class="box-tools pull-right">
      <button type="button" data-widget="" class="btn btn-box-tool"><i class="fa fa-minus"></i></button>
      <button type="button" data-widget="" class="btn btn-box-tool"><i class="fa fa-remove"></i></button>
    </div>
  </div>  
  <!----> 

  <section class="content1">
    <div class="form-group">
      <div class="row">
        <div class="col-md-4">
          <v-select :options="branches" label="name" name="branch" v-on:input="loadBranchData()" placeholder="Select" v-model="branch"></v-select>
        </div>
        <div class="col-md-4">
          <v-select :options="branchLedgers" label="name" name="ledger" placeholder="Select" v-model="filter.branchLedger"></v-select>
        </div>
        <div class="col-md-4">
            <select v-model="filter.voucherType" name="voucher" placeholder="Voucher Type" class="form-control" >
                <option selected value="">Select Voucher</option>
                <option value="payment">Payment</option>
                <option value="receipt">Receipt</option>
                <option value="journal">Journal</option>
                <option value="contra">Contra</option>
            </select>
        </div>
        <div class="col-md-3">
          <label>Date</label>
          <input v-model="date" type="date" name="startdate" class="form-control"  />
        </div>
        <!-- <div class="col-md-3">
          <label>Start Date</label>
          <input v-model="filter.startDate" type="date" name="startdate" class="form-control"  />
        </div>
        <div class="col-md-3">
          <label>End Date</label>
          <input v-model="filter.endDate" type="date" name="enddate" class="form-control" />
        </div> -->
        <div class="col-md-2">
          <label></label>
          <button type="button" @click="changeFilter()"  class="form-control btn-info"><i class="fa fa-search"></i> GET RECORDS</button>
        </div>
        .<br>
      </div>
    </div>

  </section>         
</div>


<div class="box box-primary">
  <div class="box-header with-border"> 
    <h3 class="box-title">Ledgers</h3>
    <div class="box-tools pull-right">
      <a :v-if="filter.branchLedger" :href="`${this.$axios.defaults.baseURL}/voucher/export/excel?branch_id=${branch.id}&branch_ledger_id=${filter.branchLedger.id}&all=all`" class="btn btn-box-tool" v-if="canAccess('voucher-create')">
        <i class="fa fa-file-excel-o"></i> Download Excel
      </a>
      <a :v-if="filter.branchLedger" :href="`${this.$axios.defaults.baseURL}/financialstatement/export/excel?branch_id=${branch.id}&branch_ledger_id=${filter.branchLedger.id}&all=all`" class="btn btn-box-tool" v-if="canAccess('voucher-create')">
        <i class="fa fa-file-excel-o"></i> Download Financial Statement
      </a>
      <!-- <button @click="print()" class="float-right btn btn-sm btn-primary"><i class="fa fa-print"></i> Print</button> -->
    </div>
  </div>  
  <!----> 
  <section class="content" id="print">
    <div class="row">
      <div v-if="filter.branchLedger" class="col-md-12 bg-green">
        <center><strong>{{filter.branchLedger.name}}</strong></center>
      </div>
      <div class="col-md-12" style="background-color: #FFFFD9;">  
        <div class="row">
          <div class="col-sm-12">
              <table class="table table-bordered table-hover table-striped table-responsive">
                  <thead style="background-color: #d6dddd;">
                      <tr>
                          <th rowspan="2" width="5%">SN</th>
                          <th rowspan="2" width="7%">Date</th>
                          <th rowspan="2" width="20%">Member</th>
                          <th rowspan="2" width="10%">VoucherNo</th>
                          <th rowspan="2" width="10%">Type</th>
                          <th rowspan="2" width="25%">Particular</th>
                          <th colspan="3" width="30%">Amount</th>
                          <!-- <th rowspan="2" width="5%">View</th> -->
                      </tr>
                      <tr>
                          <th>Dr.</th>
                          <th>Cr.</th>
                          <th>Balance</th>
                      </tr>
                  </thead>
                  <tbody style="background-color: #c5c9cc8f;">
                    <tr v-for="(row, index) in ledgerItems" :key="index" v-show="row.drAmt > 0 || row.crAmt > 0">
                      <td>{{ index + 1 }}</td>
                      <td>{{row.date | myDate}}</td>
                      <td>{{row.member}}</td>
                      <td>{{row.voucherNo}}</td>
                      <td>{{row.voucherType}}</td>
                      <td>{{row.ledger.name}}</td>
                      <td>{{row.drAmt }}</td>
                      <td>{{row.crAmt}}</td>
                      <td>{{ (parseFloat(row.balance)).toFixed(2) }}</td>
                      <!-- <td>
                        <div class="btn-group" role="group" aria-label="...">
                          <button type="button" @click="showVoucher(row)" class="btn btn-info btn-xs" data-toggle="modal" data-target="#showVoucharModal"><i class="fa fa-eye"></i></button>
                          <button v-if="!row.disbursementId" type="button" @click="deleteVoucher(row.voucherId)" class="btn btn-danger btn-xs" ><i class="fa fa-trash"></i></button>
                        </div>
                      </td> -->
                    </tr>
                    <tr>
                      <td colspan="6"></td>
                      <td class="label-success"><strong><span class="pull-left">DR</span><span class="pull-right">{{(drTotalAmt).toFixed(2)}}</span></strong></td>
                      <td class="label-info"><strong><span class="pull-left">CR</span><span class="pull-right">{{(crTotalAmt).toFixed(2)}}</span></strong></td>
                      <td class="label-primary"><strong><span class="pull-left">{{balanceType}}</span><span class="pull-right">{{(totalBalanceAmt).toFixed(2)}}</span></strong></td>
                      <td></td>
                    </tr>
                    <!-- <tr>
                      <td colspan="4"></td>
                      <td colspan="3"><strong>{{totalBalanceAmt}} {{balanceType}}</strong></td>
                    </tr> -->
                  </tbody>
              </table>
              
              <br>
          </div>
        </div>
      </div>
      <hr>
    </div>
  </section>
</div>

    <!-- The modal -->
    <div class="modal fade" id="showVoucharModal" tabindex="-1" role="dialog" aria-labelledby="modalLabelSmall" aria-hidden="true">
      <div class="modal-dialog modal-md">
        <div class="modal-content">

          <div class="modal-header label-danger">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="modalLabelSmall">Voucher</h4>
          </div>

          <div class="modal-body">
            <div class="row label-primary">
              <div class="col-md-4"><strong>Date:</strong> {{voucher.date}}</div>
              <div class="col-md-4"><strong>Voucher:</strong> {{voucher.voucherNo}}</div>
              <div class="col-md-4"><strong>Voucher Type:</strong> {{voucher.voucherType}}</div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-6">
                <div class="label-default"><strong>DR Ledger</strong></div><hr>
                <table class="table ">
                  <tr v-for="(dledger, index) in voucher.dr_ledger" :key="index">
                    <td>{{dledger.ledger.name}}</td>
                    <td class="pull-right">{{dledger.amt}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <th class="pull-right"><strong>Dr:{{ voucher_sum(voucher.dr_ledger) }}</strong></th>
                  </tr>
                </table>
              </div>
              <div class="col-md-6">
                <div class="label-default"><strong>CR Ledger</strong></div><hr>
                <table class="table ">
                  <tr v-for="(cledger, index) in voucher.cr_ledger" :key="index">
                    <td>{{cledger.ledger.name}}</td>
                    <td class="pull-right">{{cledger.amt}}</td>
                  </tr>
                  <tr>
                    <td></td>
                    <th class="pull-right"><strong>Cr:{{ voucher_sum(voucher.cr_ledger) }}</strong></th>
                  </tr>
                </table>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-md-12"><strong>Narration:</strong> {{voucher.narration}}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
      
</div>
</template>

<script>
// import GetBranch from '../../mixins/BranchRecords'
var _ = require('lodash')
export default {
  name: 'Voucher',
  // mixins: [GetBranch],
  data () {
    return {
      pagination: {
        current_page: 0,
        from: 0,
        to: 0,
        total: 0,
        last_page: 0,
        per_page: 0,
        first_page_url: null,
        last_page_url: null,
        next_page_url: null,
        prev_page_url: null,
        path: null
      },
      per_page: 100,
      editMode: false,
      branches: [],
      branchLedgers: [],
      vouchers: [],
      voucher: {},
      date: '',
      filter: {
        voucherType: '',
        startDate: '',
        endDate: '',
        branchLedger: {id: ''}
      },
      form: new Form({
        id: '',
        voucherNo: '',
        date: '',
        voucherType: '',
        dr_ledger_id: '',
        cr_ledger_id: '',
        amt: '',
        status: ''
      }),
      drledgers: [],
      crledgers: [],
      holdVoucher: {},
      holdVouchers: [],
      branch: {},
      branchLedger: {},
      amt: Number,
      total: 0,
      ledgerItems: [],
      drTotalAmt: 0,
      crTotalAmt: 0,
      balance: 0,
      totalBalanceAmt: 0,
      balanceType: ''
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    showVoucher (row) {
      var voucherId = row.voucherId
      this.voucher = _.find(this.vouchers, function (o) { return o.id === voucherId })
    },
    voucher_sum (voucher) {
      return _.sumBy(voucher, function (o) { return +o.amt })
    },
    deleteVoucher (voucherId) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$axios
            .delete('voucher/' + voucherId, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
            .then((data) => {
              // console.log(data)
              Fire.$emit('AfterCreate')
              Swal.fire('Deleted!', 'Your entry has been deleted.', 'success')
            }).catch(function (error) { console.log(error) })
        }
      })
    },
    print () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('print').innerHTML

      // Get all stylesheets HTML
      let stylesHtml = ''
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')

      WinPrint.document.write(`<!DOCTYPE html>
                              <html>
                                  <head>
                                      ${stylesHtml}
                                  </head>
                                  <body>
                                      ${prtHtml}
                                  </body>
                              </html>`)

      WinPrint.document.close()
      WinPrint.focus()
      WinPrint.print()
      WinPrint.close()
    },
    async changeFilter (page = null, pg = null) {
      this.crTotalAmt = 0.00
      this.drTotalAmt = 0.00
      this.totalBalanceAmt = 0.00
      this.balance = 0.00
      this.balanceType = ''

      var pageUrl = ''
      pageUrl += 'financialyearvoucherstatement?all=all'

      if (this.filter.voucherType) {
        pageUrl += `&voucherType=${this.filter.voucherType}`
      }
      pageUrl += `&branch_id=${this.branch.id}&branch_ledger_id=${this.filter.branchLedger.id}`
      if (this.date) {
        pageUrl += `&date=${this.date}`
      }
      if (this.filter.startDate) {
        pageUrl += `&startDate=${this.filter.startDate}`
      }
      if (this.filter.endDate) {
        pageUrl += `&endDate=${this.filter.endDate}`
      }
      if (page != null) {
        pageUrl += `&page=${page}`
      }
      await this.$axios
        .post(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
        //   console.log(data)
          this.vouchers = data

          this.ledgerItems = data.ledgerItems
          this.balance = data.balance
          this.drTotalAmt = data.drTotalAmt
          this.crTotalAmt = data.crTotalAmt
          this.totalBalanceAmt = data.balance
          this.balanceType = data.balanceType
        }).catch(function (error) { console.log(error) })
    },
    loadBranchData () {
      this.branchLedgers = []
      this.filter.branchLedger = {}
      this.$axios
        .get('branchledger?all=all&branch_id=' + this.branch.id, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.branchLedgers = data.data
          $.each(this.branchLedgers, function (key, value) {
            this.branchLedgers[key].name = value.ledger.name
          }.bind(this))
        }).catch(function (error) { console.log(error) })
    },
    loadData () {
      this.$axios
        .get('branch?status=active&all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        }).catch(function (error) { console.log(error) })
    }
  },

  created () {
    this.loadData()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>

<style>
.row {
    padding: 2px;
}
</style>



// WEBPACK FOOTER //
// FinancialYearVoucherStatement.vue?23e42f7f